import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 安否確認(施設関係者)テンプレート API 操作クラス
 */
export default class OtherUserSafetyConfirmsTemplates {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET OtherUserSafetyConfirmsTemplates
   */
  public async get(userStore: LoginUser, id: number): Promise<OtherUserSafetyConfirmsTemplatesGetModel> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      otherUserSafetyConfirmsTemplateId: id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserSafetyConfirmTemplate, formatParams);

    const response = await this.commonService.executeGet<OtherUserSafetyConfirmsTemplatesGetModel>(
      userStore,
      requestUrl,
      this.constructor.name,
      {},
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }

  /**
   * ### PATCH OtherUserSafetyConfirmsTemplates
   */
  public async patch(userStore: LoginUser, id: number, requestBody: OtherUserSafetyConfirmsTemplatesPatchModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      otherUserSafetyConfirmsTemplateId: id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserSafetyConfirmTemplate, formatParams);

    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface OtherUserSafetyConfirmsTemplatesGetModel {
  /** 施設ID */
  facilityId: number;
  /** 安否確認(施設関係者)テンプレートID */
  id: number;
  /** 使用する質問の ID 配列 */
  useIds: Array<number>;
  /**
   * デフォルトの送信先の宛先グループソートキー
   * v3.33.0以前のバージョンで使用していた
   */
  groupId: number;
  /**
   * デフォルトの宛先ソートキー（複数）
   * v3.34.0以降のバージョンでは宛先が宛先グループと施設関係者グループになった
   * 更に複数情報を保持するようになっている
   */
  targets: string[] | undefined;
  /** デフォルトの冒頭文 */
  openingSentence: string;
  /** 削除フラグ */
  deleteFlag: boolean;
  /** レコード作成日 */
  created: number;
  /** レコード更新日 */
  updated: number;
}

export interface OtherUserSafetyConfirmsTemplatesPatchModel {
  /** 使用する質問の ID 配列 */
  useIds: Array<number>;
  /**
   * デフォルトの宛先ソートキー（複数）
   * v3.34.0以降のバージョンでは宛先が宛先グループと施設関係者グループになった
   * 更に複数情報を保持するようになっている
   */
  targets: string[] | undefined;
  /** デフォルトの冒頭文 */
  openingSentence: string | null;
  /** レコード更新日 */
  updated: number;
}
